import { styled } from "@material-ui/core";
import { Search } from "shared/Search";

export const SearchInput = styled(Search)(({ theme }) => ({
  width: "100%",
  maxWidth: "21.5rem",
  height: "3.5rem"
}));
